export default class AdminLicenciaActivadaForm {

    /**
     *
     * @param {Array} props.grados
     * @param {Array} props.secciones
     */
    constructor(props) {
        this.grados = props.grados;
        this.secciones = props.secciones;
    }

    /**
     * @param {number} id
     * @param {callback} options.onSuccess
     */
    editar(id, options) {
        let myself = this;
        let modalOpts = {
            title: 'Editar datos de la licencia',
            method: 'PUT',
            url: `/api/admin/licencias/${id}/editar-activada`
        };
        if (options.onSuccess !== undefined) {
            modalOpts.buttons = {
                ok: {
                    onSuccess: function (response) {
                        options.onSuccess(response);
                    }
                }
            }
        }
        this.modal = new FormModal(modalOpts);
        Ajax.get(`/api/admin/licencias/${id}`, {
            then: function (response) {
                myself.modal.render(myself.render(response.data), function () {
                    let modalBody = document.querySelector('.bootbox-body');
                    let txtSeccion = modalBody.querySelector('#seccion');
                    let cbSeccion = modalBody.querySelector('#secciones');

                    myself.determinarSelectSecciones(cbSeccion.value, txtSeccion.value, txtSeccion);

                    $(modalBody.querySelector('#secciones')).change(function() {
                        myself.determinarSelectSecciones(this.value, '', txtSeccion);
                    });

                    $(modalBody.querySelector('#empresa_id')).select2({
                        dropdownParent: $('.bootbox-body'),
                        language: "es",
                        ajax: {
                            url: '/api/admin/empresas',
                            delay: 200,
                            data: function (params) {
                                let query = {
                                    referencia: params.term,
                                    page: params.page || 1,
                                    size: 3
                                };
                                return query;
                            },
                            processResults: function (response) {
                                let data = [];
                                response.data.forEach(i => {
                                    data.push({
                                        id: i.id,
                                        text: i.nombre_comercial
                                    });
                                });
                                return {
                                    results: data
                                };
                            }
                        },
                        minimumInputLength: 3
                    });
                });
            }
        });
    }

    determinarSelectSecciones(value, trueValue, txtSeccion) {
        if (value == 'Otros') {
            txtSeccion.value = trueValue;
            txtSeccion.classList.remove('d-none');
        } else {
            txtSeccion.value = value;
            txtSeccion.classList.add('d-none');
        }
    }

    render(licencia) {
        let htmlGrados = '';
        this.grados.forEach(g => {
            htmlGrados += `<option value="${g.id}"${(g.id == licencia.grado) ? ' selected' : ''}>${g.simbolo}</option>`;
        });
        let seccionValue = licencia.seccion;
        if (this.secciones.findIndex(s => s.id == licencia.seccion) == -1) {
            seccionValue = 'Otros';
        }
        let htmlSecciones = '';
        this.secciones.forEach(s => {
            htmlSecciones += `<option value="${s.id}"${(s.id == seccionValue) ? ' selected' : ''}>${s.nombre}</option>`;
        });
        return `<form>
        <div class="row form-group">
            <label for="nombres" class="col-form-label col col-md-4">Nombres</label>
            <div class="col col-md-8">
                <input type="text" name="nombres" id="nombres" value="${licencia.nombres}" required class="form-control form-control-sm"/>
            </div>
            <label for="apellido_paterno" class="col-form-label col col-md-4">Ap. Paterno</label>
            <div class="col col-md-8">
                <input type="text" name="apellido_paterno" id="apellido_paterno" value="${licencia.apellido_paterno}" required class="form-control form-control-sm"/>
            </div>
            <label for="apellido_materno" class="col-form-label col col-md-4">Ap. Materno</label>
            <div class="col col-md-8">
                <input type="text" name="apellido_materno" id="apellido_materno" value="${licencia.apellido_materno}" required class="form-control form-control-sm"/>
            </div>
            <label for="correo" class="col-form-label col col-md-4">Correo</label>
            <div class="col col-md-8">
                <input type="email" name="correo" id="correo" value="${licencia.correo}" required class="form-control form-control-sm"/>
            </div>
            <label for="empresa_id" class="col-form-label col col-md-4">Colegio</label>
            <div class="col col-md-8">
                <select class="form-select form-select-sm" name="empresa_id" id="empresa_id" required>
                    <option value="${licencia.empresa_id}" selected>${licencia.empresa_nombre}</option>
                </select>
            </div>
            <label for="grado" class="col-form-label col col-md-4">Grado</label>
            <div class="col col-md-8">
                <select class="form-select form-select-sm" name="grado" id="grado" required>
                ${htmlGrados}
                </select>
            </div>
            <label for="secciones" class="col-form-label col col-md-4">Sección</label>
            <div class="col col-md-8">
                <select class="form-select form-select-sm" name="secciones" id="secciones" required>
                ${htmlSecciones}
                </select>
                <input type="text" name="seccion" id="seccion" value="${licencia.seccion}" required class="form-control form-control-sm d-none my-1"/>
            </div>
        </div>
        </form>`;
    }
}
